export const deleteProperty = (obj, optin_date, user_fb, id) => {
  delete obj[optin_date];
  delete obj[user_fb];
  delete obj[id];

  return obj;
};
